module.exports = __webpack_public_path__ + "static/media/wallet.0d0cb0e7.svg";